/**
 * Minimal folded cache — stores decrypted Concord community list plaintext
 * in localStorage so the rail doesn't blank while waiting for a remote signer.
 */

const PREFIX = "onegroup:folded:";

export async function readFolded<T>(key: string): Promise<T | null> {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export async function writeFolded<T>(key: string, value: T): Promise<void> {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    // Storage full or unavailable — silent no-op
  }
}